"use strict";
import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
var $Map = typeof Map === "function" && Map.prototype ? Map : null;
var $Set = typeof Set === "function" && Set.prototype ? Set : null;
var exported;
if (!$Set) {
    // eslint-disable-next-line no-unused-vars
    exported = function isSet(x) {
        // `Set` is not present in this environment.
        return false;
    };
}
var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$setHas) {
    // eslint-disable-next-line no-unused-vars
    exported = function isSet(x) {
        // `Set` does not have a `has` method
        return false;
    };
}
module.exports = exported || function isSet(x) {
    if (!x || typeof x !== "object") {
        return false;
    }
    try {
        $setHas.call(x);
        if ($mapHas) {
            try {
                $mapHas.call(x);
            } catch (e) {
                return true;
            }
        }
        return _instanceof(x, $Set); // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};
